import {
  NOTIFICATION_ADD_REQUEST,
  NOTIFICATION_ADD_REQUEST_SUCCESS,
  NOTIFICATION_ADD_REQUEST_FAILURE,
  NOTIFICATION_FETCH_REQUEST,
  NOTIFICATION_FETCH_REQUEST_SUCCESS,
  NOTIFICATION_FETCH_REQUEST_FAILURE,
  NOTIFICATION_CLEAN_REQUEST,
  NOTIFICATION_TYPES_FETCH_REQUEST,
  NOTIFICATION_TYPES_FETCH_REQUEST_SUCCESS,
  NOTIFICATION_TYPES_FETCH_REQUEST_FAILURE,
  NOTIFICATION_TYPES_CLEAN_REQUEST,
  NOTIFICATION_ACTION_FETCH_REQUEST,
  NOTIFICATION_ACTION_FETCH_REQUEST_SUCCESS,
  NOTIFICATION_ACTION_FETCH_REQUEST_FAILURE,
  NOTIFICATION_ACTION_CLEAN_REQUEST,
  NOTIFICATION_MERCHANT_FETCH_REQUEST,
  NOTIFICATION_MERCHANT_FETCH_REQUEST_SUCCESS,
  NOTIFICATION_MERCHANT_FETCH_REQUEST_FAILURE,
  NOTIFICATION_MERCHANT_CLEAN_REQUEST,
  NOTIFICATION_APP_FETCH_REQUEST,
  NOTIFICATION_APP_FETCH_REQUEST_SUCCESS,
  NOTIFICATION_APP_FETCH_REQUEST_FAILURE,
  NOTIFICATION_APP_CLEAN_REQUEST,
  NOTIFICATION_INTERVAL_DROPDOWN_REQUEST,
  NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_SUCCESS,
  NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_FAILURE,
  NOTIFICATION_INTERVAL_DROPDOWN_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
const INITIAL_STATE_TYPE = {
  payload: [],
  loading: false,
  errors: {},
};

const NOTIFICATION_DETAIL_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const notificationReducer = (state, action) => {
  state = state || NOTIFICATION_DETAIL_INITIAL_STATE;

  switch (action.type) {
    case NOTIFICATION_FETCH_REQUEST:
    case NOTIFICATION_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTIFICATION_FETCH_REQUEST_SUCCESS:
    case NOTIFICATION_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case NOTIFICATION_FETCH_REQUEST_FAILURE:
    case NOTIFICATION_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTIFICATION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export const notificationTypesReducer = (state, action) => {
  state = state || INITIAL_STATE_TYPE;

  switch (action.type) {
    case NOTIFICATION_TYPES_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTIFICATION_TYPES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        // pagination: {
        //   current: action.data.currentPage,
        //   pageSize: action.data.pageSize,
        //   total: action.data.totalRecord,
        //   totalPage: action.data.totalPage,
        //   showSizeChanger: true,
        // },
      });

    case NOTIFICATION_TYPES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTIFICATION_TYPES_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        // pagination: {
        //   current: 0,
        //   pageSize: 0,
        //   total: 0,
        //   totalPage: 0,
        // },
      });

    default:
      return state;
  }
};

export const notificationActionReducer = (state, action) => {
  state = state || INITIAL_STATE_TYPE;

  switch (action.type) {
    case NOTIFICATION_ACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTIFICATION_ACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        // pagination: {
        //   current: action.data.currentPage,
        //   pageSize: action.data.pageSize,
        //   total: action.data.totalRecord,
        //   totalPage: action.data.totalPage,
        //   showSizeChanger: true,
        // },
      });

    case NOTIFICATION_ACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTIFICATION_ACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        // pagination: {
        //   current: 0,
        //   pageSize: 0,
        //   total: 0,
        //   totalPage: 0,
        // },
      });

    default:
      return state;
  }
};

export const notificationMerchantReducer = (state, action) => {
  state = state || INITIAL_STATE_TYPE;

  switch (action.type) {
    case NOTIFICATION_MERCHANT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTIFICATION_MERCHANT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        // pagination: {
        //   current: action.data.currentPage,
        //   pageSize: action.data.pageSize,
        //   total: action.data.totalRecord,
        //   totalPage: action.data.totalPage,
        //   showSizeChanger: true,
        // },
      });

    case NOTIFICATION_MERCHANT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTIFICATION_MERCHANT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        // pagination: {
        //   current: 0,
        //   pageSize: 0,
        //   total: 0,
        //   totalPage: 0,
        // },
      });

    default:
      return state;
  }
};

export const notificationAppReducer = (state, action) => {
  state = state || INITIAL_STATE_TYPE;

  switch (action.type) {
    case NOTIFICATION_APP_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTIFICATION_APP_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        // pagination: {
        //   current: action.data.currentPage,
        //   pageSize: action.data.pageSize,
        //   total: action.data.totalRecord,
        //   totalPage: action.data.totalPage,
        //   showSizeChanger: true,
        // },
      });

    case NOTIFICATION_APP_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTIFICATION_APP_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        // pagination: {
        //   current: 0,
        //   pageSize: 0,
        //   total: 0,
        //   totalPage: 0,
        // },
      });

    default:
      return state;
  }
};

export const notificationIntervalReducer = (state, action) => {
  state = state || INITIAL_STATE_TYPE;

  switch (action.type) {
    case NOTIFICATION_INTERVAL_DROPDOWN_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        // pagination: {
        //   current: action.data.currentPage,
        //   pageSize: action.data.pageSize,
        //   total: action.data.totalRecord,
        //   totalPage: action.data.totalPage,
        //   showSizeChanger: true,
        // },
      });

    case NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTIFICATION_INTERVAL_DROPDOWN_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        // pagination: {
        //   current: 0,
        //   pageSize: 0,
        //   total: 0,
        //   totalPage: 0,
        // },
      });

    default:
      return state;
  }
};

export default notificationReducer;
